module.exports = __webpack_public_path__ + "img/symbol-up-down.a3bb8110.png";